"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardHierarchyLevel = void 0;
exports.getStandardHierarchyLevel = getStandardHierarchyLevel;
exports.getStandardHierarchyLevelEM = getStandardHierarchyLevelEM;
exports.getStandardHierarchyLevelEMTX = getStandardHierarchyLevelEMTX;
exports.getStandardHierarchyLevelFrom = getStandardHierarchyLevelFrom;
var StandardHierarchyLevel;
(function (StandardHierarchyLevel) {
    StandardHierarchyLevel["Standard"] = "Standard";
    StandardHierarchyLevel["Domain"] = "Domain";
    StandardHierarchyLevel["Cluster"] = "Cluster Statement";
    StandardHierarchyLevel["Strand"] = "Strand";
    StandardHierarchyLevel["KnowledgeSkill"] = "Knowledge/Skill";
    StandardHierarchyLevel["GradeLevelStandard"] = "Grade Level Standard";
})(StandardHierarchyLevel || (exports.StandardHierarchyLevel = StandardHierarchyLevel = {}));
function getStandardHierarchyLevel() {
    return Object.values(StandardHierarchyLevel);
}
function getStandardHierarchyLevelEM() {
    return [
        StandardHierarchyLevel.Standard,
        StandardHierarchyLevel.Cluster,
        StandardHierarchyLevel.Domain,
    ];
}
function getStandardHierarchyLevelEMTX() {
    return [StandardHierarchyLevel.KnowledgeSkill, StandardHierarchyLevel.Strand];
}
function getStandardHierarchyLevelFrom(value) {
    return getStandardHierarchyLevel().find(function (type) { return type === value; });
}
